import * as yup from 'yup';

const DEFAULT_MESSAGE = 'Este campo es requerido.';

const postCodeYup = yup.object().shape({
    id: yup.number(),
    title: yup.string().required(DEFAULT_MESSAGE),
    post_code: yup
        .number()
        .transform((value) => (isNaN(value) || value === null || value === undefined ? -1 : value))
        .required(DEFAULT_MESSAGE)
        .min(1, 'Use un valor mayor a cero'),
    latitude: yup.string().required(DEFAULT_MESSAGE),
    longitude: yup.string().required(DEFAULT_MESSAGE),
    active: yup.boolean(),
    ends_at: yup.string().required(DEFAULT_MESSAGE)
});

export { postCodeYup };
